/* (function () {
  document.addEventListener('DOMContentLoaded', function () {
    var tabs = document.querySelectorAll('.vertical-tabs__item');
    var accordionTabs = document.querySelectorAll('.vertical-tabs__item-accordion');
    var tabContents = document.querySelectorAll('.vertical-tabs__content > .tab-image');
    const selectedClass = 'vertical-tabs__item--selected';

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        // Toggle the active class on the tabs
        tabs.forEach(function (tab) {
          tab.classList.remove('active');
        });
        this.classList.add('active');

        if (this.classList.contains('fixed')) return;

        // Show the corresponding tab content
        tabContents.forEach(function (content) {
          content.style.display = 'none';
        });
        tabContents[index].style.display = 'block';
      });
    });

    // accordionTabs.forEach(function (tab, index) {
    //   tab.addEventListener('click', function () {
    //     if (this.classList.contains(selectedClass)) {
    //       tab.classList.remove(selectedClass);
    //     } else {
    //       tabs.forEach(function (tab) {
    //         tab.classList.remove(selectedClass);
    //       });
    //       this.classList.add(selectedClass);
    //     }

    //     const itemDescription = this.querySelector('.vertical-tabs__item-description');

    //     if (this.classList.contains(selectedClass)) {
    //       itemDescription.style.maxHeight = 0;
    //       itemDescription.style.opacity = 0;
    //       itemDescription.style.margin = 0;
    //     } else {
    //       itemDescription.style.maxHeight = itemDescription.scrollHeight + 'px';
    //       itemDescription.style.opacity = 1;
    //     }

    //     if (this.classList.contains('fixed')) return;

    //     // Show the corresponding tab content
    //     tabContents.forEach(function (content) {
    //       content.style.display = 'none';
    //     });
    //     tabContents[index].style.display = 'block';

    //   });
    // });
    accordionTabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        if (this.classList.contains(selectedClass)) {
          tab.classList.remove(selectedClass);
        } else {
          tabs.forEach(function (tab) {
            tab.classList.remove(selectedClass);
          });
          this.classList.add(selectedClass);
        }

        const itemDescription = this.querySelector('.vertical-tabs__item-description');

        if (itemDescription) {
          if (this.classList.contains(selectedClass)) {
            itemDescription.style.maxHeight = 0;
            itemDescription.style.opacity = 0;
            itemDescription.style.margin = 0;
          } else {
            itemDescription.style.maxHeight = itemDescription.scrollHeight + 'px';
            itemDescription.style.opacity = 1;
          }
        }

        if (this.classList.contains('fixed')) return;

        // Show the corresponding tab content
        tabContents.forEach(function (content) {
          content.style.display = 'none';
        });
        tabContents[index].style.display = 'block';
      });
    });



  });
})(); */

$(document).ready(function () {
  // Initially, hide all the item descriptions
  $('.vertical-tabs__item-description').hide();
  $('.vertical-tabs__item.active').find('.vertical-tabs__item-description').slideDown();
  $('.vertical-tabs__item-accordion.active').find('.vertical-tabs__item-description').slideDown();

  // Add click event to each item
  $('.vertical-tabs__item').click(function () {
    const index = $(this).index();

    $(this).siblings().find('.vertical-tabs__item-description').slideUp();

    // Toggle the item description of the clicked item
    $(this).find('.vertical-tabs__item-description').slideToggle('fast');

    // Add and remove the 'active' class
    $(this).toggleClass('active').siblings().removeClass('active');

    // Select all images matching the selector
    var allImages = $('.vertical-tabs__content > .tab-image');

    // Hide all images initially
    allImages.hide();

    // Show the image at the dynamic index
    allImages.eq(index).show();
  });

  $('.vertical-tabs__item-accordion').click(function () {
    const index = $(this).index();

    $(this).siblings().find('.vertical-tabs__item-description').slideUp();

    // Toggle the item description of the clicked item
    $(this).find('.vertical-tabs__item-description').slideToggle('fast');

    // Add and remove the 'active' class
    $(this).toggleClass('active').siblings().removeClass('active');

    // Select all images matching the selector
    var allImages = $(this).parent().parent().parent().find('.vertical-tabs__content > .tab-image');

    // Hide all images initially
    allImages.hide();

    // Show the image at the dynamic index
    allImages.eq(index).show();
  });
});
